import { render, staticRenderFns } from "./RPCheckbox.vue?vue&type=template&id=74c4e952&scoped=true&"
import script from "./RPCheckbox.vue?vue&type=script&lang=js&"
export * from "./RPCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./RPCheckbox.vue?vue&type=style&index=0&id=74c4e952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c4e952",
  null
  
)

/* custom blocks */
import block0 from "./RPCheckbox.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports